<template>
  <layout-basic>
    <v-container fluid class="text-left">
      <v-row>
        <v-col md="8" offset-md="2">
          <div class="faq-section">
            <h3>1. How many users can I enrol?</h3>
            <p>This depends on the banding you are on for IMPROVE. To check this simply go to the Finance / Account Info section or the Users section from the Admin menu. If you need to add more people to your IMPROVE system than your current banding allows, go to the Finance / Account Info section and upgrade to the next level.</p>
          </div>
          <div class="faq-section">
            <h3>2. How many admins can I have?</h3>
            <p>1</p>
          </div>
          <div class="faq-section">
            <h3>3. What happens if I want to cancel my subscription before the contract end period?</h3>
            <p>We will be sorry to see you go! For us to provide you with such excellent value, IMPROVE comes as a 12-month contract. This means that you have signed up for this period and cannot cancel it.</p>
          </div>
          <div class="faq-section">
            <h3>4. How do I cancel my subscription?</h3>
            <p>If you do wish to cancel your contract with us go the Finance / Account Info section from the Admin menu and cancel the automatic renewal at least 30-days before it is due to renew. We will take care of the rest for you, so you won’t be signed up to another 12-months.</p>
          </div>
          <div class="faq-section">
            <h3>5. How do I contact you about an issue?</h3>
            <p>We provide free help and support to all our customers. If you cannot find the information you want in this FAQ section, then try the more in depth ‘How to Guides’. If you still need to speak to one of us click on the Help Desk icon and chat to someone online who will be happy to help.</p>
          </div>
          <div class="faq-section">
            <h3>6. How do I delete employee data?</h3>
            <p>You can delete a user and their data at any time. Go to the Users section from the Admin menu and select the delete user icon. This will delete the user and their data permanently from IMPROVE.</p>
          </div>
          <div class="faq-section">
            <h3>7. How do I export data from IMPROVE?</h3>
            <p>You can export data from IMPROVE using the Report function accesses from the Admin menu. Select the report you wish to run and export the data via PDF or CSV, whichever is better for you.</p>
          </div>
          <div class="faq-section">
            <h3>8. What types of files can I upload?</h3>
            <p>You can upload most file types which include….</p>
          </div>
          <div class="faq-section">
            <h3>9. What is my storage limit for uploading files?</h3>
            <p>There is no limit on the storage you can take advantage of within IMPROVE. We do however run a fair use policy, and should your storage exceed the following levels, we reserve the right to charge you a little extra.</p>
          </div>
          <div class="faq-section">
            <h3>10. What is the Marketplace?</h3>
            <p>The Marketplace is a part of IMPROVE which will launch in 2020. This will provide valued customers of IMPROVE, such as yourself, to access other products and services which we feel might be of use. We specially select partners to work with to ensure that their products or services offer real value to businesses under 250 employees.</p>
            <p>These partners will be providing such services as HR Management software, employee benefits and payroll management, HR documentation to name a few. But don’t worry we won’t bombard you with marketing bumph or allow them to either! You choose if you want to take advantage of what’s on offer.</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/Dashboard";
export default {
  components: {
    LayoutBasic
  }
};
</script>